import { render } from "./AuthenticatePage.vue?vue&type=template&id=65ed5722"
import script from "./AuthenticatePage.vue?vue&type=script&lang=js"
export * from "./AuthenticatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__